function adjustMenuTop() {
  var adminBarHeight = jQuery('#wpadminbar').outerHeight();
  var headerTop = -(jQuery(window).scrollTop() - jQuery('#header').position().top);
  var headerHeight = jQuery('#header').outerHeight();
  var menuButtonHeight = jQuery('#responsive-menu-button').outerHeight();

  jQuery('.sticky-top').css({ 'top': (jQuery(window).width() >= 600 ? adminBarHeight : 0) + 'px' });
  jQuery('#responsive-menu-container').css({ 'top': headerTop + 'px' });
  jQuery('#responsive-menu-button').css({ 'top': (headerTop + headerHeight / 2 - menuButtonHeight / 2) + 'px' });
}

function changeParticularFields(value, type) {
  if (type == 'billing') {
    jQuery('#billing_treatment_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#billing_first_name_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#billing_last_name_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#billing_business_name_field').css('display', value != 1 ? 'none' : 'block');
    jQuery('#billing_birthdate_field').css('display', value == -1 ? 'block' : 'none');

    jQuery('#wcmca_billing_treatment_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_billing_first_name_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_billing_last_name_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_billing_business_name_field').css('display', value != 1 ? 'none' : 'block');
    jQuery('#wcmca_billing_birthdate_field').css('display', value == -1 ? 'inline-block' : 'none');
  } else {
    jQuery('#shipping_treatment_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#shipping_first_name_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#shipping_last_name_field').css('display', value == -1 ? 'block' : 'none');
    jQuery('#shipping_business_name_field').css('display', value != 1 ? 'none' : 'block');
    jQuery('#shipping_birthdate_field').css('display', value == -1 ? 'block' : 'none');
    
    jQuery('#wcmca_shipping_treatment_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_shipping_first_name_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_shipping_last_name_field').css('display', value == -1 ? 'inline-block' : 'none');
    jQuery('#wcmca_shipping_business_name_field').css('display', value != 1 ? 'none' : 'block');
    jQuery('#wcmca_shipping_birthdate_field').css('display', value == -1 ? 'inline-block' : 'none');
  }
}

function manageAlertNotification(element) {
  setTimeout(function() {
    element.fadeOut('fast');
  }, 5000);
  
  manageAlertNotificationStyles();
}

function manageAlertNotificationStyles() {
  jQuery('body:not(.single-product) .woocommerce-message').addClass('no-flow');
  jQuery('body:not(.single-product) .woocommerce-message a').addClass('button');

  jQuery('.woocommerce-error').addClass('custom-error-notification');
  jQuery('.woocommerce-error a').addClass('button');
}

function manageCustomAddressRequiredFields(field, conditional) {
  var label = jQuery(`label[for=${field}]`);
  var input = jQuery(`#${field}`);

  if (label.find('span').length > 0) {
    label.find('span').remove();
    label.append('<abbr class="required" title="obligatorio">*</abbr>');
  }

  if (conditional) {
    if (jQuery(this).val() == '-1') { // Particular
      input.removeClass('not_empty');
    } else {
      input.addClass('not_empty');
    }
  } else {
    input.addClass('not_empty');
  }
}

export default {
  init() {
    jQuery(window).on('resize', adjustMenuTop);
    jQuery(window).on('scroll', adjustMenuTop);
    adjustMenuTop();

    // Control de los nuevas alertas que salen de WC
    manageAlertNotification(jQuery(document).find('.woocommerce-message, .woocommerce-error'));

    jQuery(document).on('DOMNodeInserted', function(e) {
      var element = jQuery(e.target);
      if (element.is('.woocommerce-message') || element.is('.woocommerce-error')) {
        manageAlertNotification(element);
      } else if (element.is('.mfp-wrap')) {
        jQuery('#wcmca_billing_is_business').change();
      }
    });

    // Control de los campos personalizados para las direcciones
    jQuery(document).on('change', '#billing_is_business, #wcmca_billing_is_business', function() {
      if (jQuery(this).is(':visible')) {
        setTimeout(() => {
          changeParticularFields(jQuery(this).val(), 'billing'); // 0 -> Nada | 1 -> Empresa | -1 -> Particular
        }, 500);
      }
    });

    jQuery('#wcmca_billing_is_business').on('change', function() {
      manageCustomAddressRequiredFields('wcmca_billing_is_business');
      manageCustomAddressRequiredFields('wcmca_billing_business_name', true);
    });

    jQuery('#billing_is_business').change();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js